import styled from 'vue3-styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 12px;
  max-width: 500px;
  width: 100%;
  max-height: 80vh;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  animation: slideInUp 0.3s ease-out;
    
  @keyframes slideInUp {
      from {
          opacity: 0;
          transform: translateY(40px) scale(0.95);
      }
      to {
          opacity: 1;
          transform: translateY(0) scale(1);
      }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e5e7eb;
  background: linear-gradient(135deg, #0f4c5c 0%, #1a6b7a 100%);
`;

export const ModalTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: white;
  margin: 0;
`;

export const ModalCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  color: white;
  cursor: pointer;
  padding: 5px;
  border-radius: 4px;
  
  &:hover {
    background: #f1f5f9;
    color: #334155;
  }
`;

export const ModalBody = styled.div`
  padding: 15px;
  overflow-y: auto;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 24px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
`;

export const ModalButton = styled.button`
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 80px;
  
  &.primary {
    background: linear-gradient(135deg, #0f4c5c 0%, #1a6b7a 100%);
    color: white;
    box-shadow: 0 4px 15px rgba(15, 76, 92, 0.2);
    
    &:hover {
      background: linear-gradient(135deg, #1a6b7a 0%, #0f4c5c 100%);
      transform: translateY(-1px);
      box-shadow: 0 6px 20px rgba(15, 76, 92, 0.3);
    }
    
    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 10px rgba(15, 76, 92, 0.2);
    }
  }
  
  &.secondary {
    background: #ffffff;
    color: #64748b;
    border: 2px solid #e2e8f0;
    
    &:hover {
      background: #f8fafc;
      color: #334155;
      border-color: #cbd5e1;
    }
    
    &:active {
      background: #f1f5f9;
    }
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(15, 76, 92, 0.1);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none !important;
  }
`;

export const RegistrationFormContainer = styled.div`
    max-height: 500px;
    overflow-y: auto;
    padding: 0;
`;

export const FormRow = styled.div`
    display: flex;
    gap: 16px;
    margin-bottom: 20px;
`;

export const FormGroup = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    
    &.full-width {
        flex: none;
        width: 100%;
    }
`;

export const FormLabel = styled.label`
    font-size: 15px;
    font-weight: 600;
    color: #374151;
    margin-bottom: 6px;
    display: block;
`;

export const FormInput = styled.input`
    padding: 12px 16px;
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    font-size: 14px;
    transition: all 0.2s ease;
    background: #ffffff;
    color: #1f2937;
    
    &:focus {
        outline: none;
        border-color: #0f4c5c;
    }
    
    &::placeholder {
        color: #9ca3af;
    }
    
    &[readonly] {
        background: #f9fafb;
        color: #6b7280;
        cursor: pointer;
        
        &:hover {
            background: #f3f4f6;
        }
    }
`;

export const FormSelect = styled.select`
    padding: 12px 16px;
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    font-size: 14px;
    transition: all 0.2s ease;
    background: #ffffff;
    color: #1f2937;
    
    &:focus {
        outline: none;
        border-color: #0f4c5c;
    }
`;

export const ModernAddressSearchBtn = styled.button`
    padding: 12px 20px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    border-radius: 12px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:hover {
        transform: translateY(-2px);
    }
    
    /* 반응형 디자인 */
    @media (max-width: 768px) {
        padding: 10px 16px;
        font-size: 12px;
        min-width: 100px;
    }
`;

export const ModernAddressInputGroup = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
    position: relative;
    
    ${FormInput} {
        flex: 1;
        transition: all 0.3s ease;
        
        &:focus {
            border-color: #667eea;
            box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }
    }
    
    /* 주소 입력 필드에 현대식 스타일 적용 */
    ${FormInput}[readonly] {
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        border: 2px solid #e2e8f0;
        color: #475569;
        cursor: pointer;
        
        &:hover {
            background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
            border-color: #cbd5e1;
        }
        
        &:focus {
            background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
            border-color: #667eea;
            color: #1e293b;
        }
    }
`;

export const AddressSearchIcon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    margin-right: 6px;
    
    &::before {
        content: '🔍';
        font-size: 14px;
    }
`;

// 스크롤바 스타일링
export const scrollbarStyles = `
    &::-webkit-scrollbar {
        width: 6px;
    }
    
    &::-webkit-scrollbar-track {
        background: #f1f5f9;
        border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
        background: #cbd5e1;
        border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
        background: #94a3b8;
    }
`;